<template>
  <admin-layout
    :table-headers="headers"
    :table-items="users"
    :edit-item="editUser"
    :delete-item="deleteUser"
    :edittable="false"
    :search="search"
  >
    <template v-slot:header>
      <snackbar ref="alert" class="mb-5"></snackbar>
      <header-section header-title="Users" v-model="search"></header-section>
    </template>
  </admin-layout>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import AdminLayout from "@/layouts/AdminLayout.vue";
import HeaderSection from "@/components/HeaderSection.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    AdminLayout,
    HeaderSection,
    Snackbar
  },
  data: () => ({
    search: "",
    headers: [
      { text: "Name", align: "left", value: "displayName" },
      { text: "Email", value: "email", align: "left" },
      { text: "Is Admin", value: "isAdmin", sortable: false, align: "left" },
      { text: "Created", value: "created_on", align: "left" },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    unsubscribeFromStoreAlerts: undefined
  }),
  computed: {
    users() {
      return Object.values(this.$store.state.users);
    }
  },
  methods: {
    ...mapActions(["retrieveUsersFromServer", "updateUser", "destroyUser"]),
    ...mapMutations(["showLoading", "hideLoading"]),
    editUser(user) {
      const title = user.isAdmin ? "Make User Admin" : "Revoke Admin Status";
      const message = user.isAdmin
        ? `Are you sure you wish to make '${user.displayName}' an Admin?`
        : `Are you sure you wish to revoke ${user.displayName}'s admin status?`;
      this.$root
        .$confirm(title, message, {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            this.showLoading();
            this.updateUser(user);
            this.hideLoading();
          } else {
            user.isAdmin = !user.isAdmin;
          }
        });
    },
    deleteUser(user) {
      this.$root
        .$confirm(
          "Delete User",
          `Are you sure you wish the '${user.displayName}' gone?`,
          {
            color: "red"
          }
        )
        .then(confirm => {
          if (confirm) {
            this.showLoading();
            this.destroyUser(user);
            this.hideLoading();
          }
        });
    },
    customAlert(type, message) {
      this.$refs.alert.open(type, message);
    }
  },
  async mounted() {
    this.showLoading();
    await this.retrieveUsersFromServer();
    this.hideLoading();
  },
  created() {
    // subcribe to alert mutation
    this.unsubscribeFromStoreAlerts = this.$store.subscribe(
      (mutation, state) => {
        if (mutation.type == "updateAlert") {
          this.customAlert(state.alert.status, state.alert.message);
        }
      }
    );
  },
  destroyed() {
    // unsubscribe from alert mutation
    this.unsubscribeFromStoreAlerts();
  }
};
</script>
